import React, { createContext, useState, useContext, ReactNode } from "react";
import { useSelector } from "react-redux";

interface ThreeDPropertiesContextType {
  threeDProperties: any;
  setThreeDProperties: React.Dispatch<React.SetStateAction<any>>;
}

const ThreeDPropertiesContext = createContext<
  ThreeDPropertiesContextType | undefined
>(undefined);

export const ThreeDPropertiesProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const three_d_settings = useSelector(
    (state: any) => state.globalData?.app_settings?.three_d
  );
  const [threeDProperties, setThreeDProperties] = useState<any>({
    autoRotate: three_d_settings?.autoRotate ?? true,
  });
  return (
    <ThreeDPropertiesContext.Provider
      value={{ threeDProperties, setThreeDProperties }}
    >
      {children}
    </ThreeDPropertiesContext.Provider>
  );
};

export const useThreeDProperties = () => {
  const context = useContext(ThreeDPropertiesContext);
  if (context === undefined) {
    throw new Error(
      "useThreeDProperties must be used within a ThreeDPropertiesProvider"
    );
  }
  return context;
};
